import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SnackbarService } from '../../../utils/snackbar/snackbar.service';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../../../api/services/login-service.service';
import { LoginUser } from '../../../api/interfaces/login';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  hide: boolean = true;
  public activeLang = 'es';
  constructor(
    private snack: SnackbarService,
    private translate: TranslateService,
    private loginApiService: LoginService
  ) {
    this.translate.setDefaultLang(this.activeLang);
  }

  userForm = new FormGroup({
    email: new FormControl(),
    password: new FormControl()
  });

  ngOnInit(): void {
  }

  onSubmit() {
    if (this.userForm.value.email && this.userForm.value.password) {
      this.iniciarSesion();
    }
  }

  iniciarSesion() {
    this.loginApiService.loginUser({
      "password": this.userForm.value.password,
      "username": this.userForm.value.email
    } as LoginUser)
      .subscribe(user => {
        this.loginApiService.handleUserData();
      },
        error => {
          if (error.status != 200) {
            console.error(error);
            switch (error.status) {
              case 401:
                this.snack.snackTranslate('snacks.error.login');
                // this.snack.snackTranslate('snacks.error.loginEmail');
                break;
              // case 404:
              //   break;
              default:
                this.snack.snackTranslate('snacks.error.generic');
                break;
            }
          } else {
             this.loginApiService.handleUserData();
          }
        });
  }

  toggleVisibilitiy(event) {
    this.hide = !this.hide;
  }
}

/*
  401: user contraseña incorrectos
  404: no registrado/no coinciden (pero validar)


*/